import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {useState} from 'react'

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const InputFileUpload = ({setFile}) => {
  const [upload,setUpload] = useState(false)
  return (
    <Button
      component="label"
      tabIndex={-1}
      startIcon={<CloudUploadIcon />}
      sx={{ position:"relative",backgroundColor:'white',color: "rgba(0, 0, 0, 0.38)",height:{ xs:44, sm:50 },width:"100%",boxShadow: "inset 1px 1px 3px rgba(0,0,0,0.2)",border:'2px solid lightgrey','&:hover': { cursor:"pointer",boxShadow: "inset 1px 1px 3px rgba(0,0,0,0.3)"
        }}}
      >
      {upload?'Uploaded':'Upload file'}
      <VisuallyHiddenInput
        type="file"
        onChange={(event) =>{setFile(event.target.files[0]);setUpload(true)}}
        multiple
      />
    </Button>
  );
}

export default InputFileUpload;
